import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Weather from './views/Weather.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/weather',
      name: 'weather',
      component: Weather,
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('./views/Admin.vue'),
      children: [
        {
          path: 'list',
          name: 'list',
          component: () => import('./views/Admin/List.vue')
        },
        {
          path: 'analysis',
          name: 'analysis',
          component: () => import('./views/Admin/Analysis.vue')

        }
      ]
    },
    // {
    //   path: '/json',
    //   name: 'json',
    //   component: () => import('./views/Json.vue'),
    // },
    {
      path: '*',
      redirect: '/',
    }
  ]
})
